import { render, staticRenderFns } from "./SuperAdminTerminal.vue?vue&type=template&id=6aa52202"
import script from "./SuperAdminTerminal.vue?vue&type=script&lang=js"
export * from "./SuperAdminTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports